const HOME = "/dashboard";

/**
 * Better Auth's own rule for a relative callbackURL, without its escape hatches: a path outside
 * it makes Microsoft sign-in fail to start, so a stricter one here means it can never refuse.
 */
const SAFE_PATH = /^\/[\w\-.+/@]*(?:\?[\w\-.+/=&%@]*)?$/;
/** Up to this many rounds of percent-decoding are checked; anything deeper is refused. */
const DECODE_ROUNDS = 3;
const FORBIDDEN = /\/\/|\\|\p{Cc}/u;

/**
 * True for a path on this site that is safe to go to after sign-in: one leading slash, no `//`,
 * no backslash and no control character, percent-encoded forms included. `redirect` on /login
 * comes from the URL, so anyone can write it: this is what keeps it from leaving the site.
 */
export function isSafeReturnPath(value: string): boolean {
  if (!SAFE_PATH.test(value)) return false;
  let text = value;
  for (let round = 0; round <= DECODE_ROUNDS; round++) {
    if (FORBIDDEN.test(text)) return false;
    let decoded: string;
    try {
      decoded = decodeURIComponent(text);
    } catch {
      return false;
    }
    if (decoded === text) return true;
    text = decoded;
  }
  return false;
}

/** Where to come back to after sign-in; undefined for the page sign-in lands on anyway. */
export function returnPathOf(location: { pathname: string; searchStr: string }) {
  const path = `${location.pathname}${location.searchStr}`;
  return path !== HOME && isSafeReturnPath(path) ? path : undefined;
}

/** Back to the login page after a failed Microsoft sign-in, still holding the return path. */
export function loginPathFor(returnPath: string | undefined): string {
  return returnPath ? `/login?redirect=${encodeURIComponent(returnPath)}` : "/login";
}
